
const state = () => ({
  cvs: [], // 列表
  cvsTotalCount: 0, // 简历总数
  onlineCvData: null,
  cvActiveIndex: null, // 当前活跃简历操作弹窗
})

export default state
